import TagManager from "react-gtm-module";
import apiConfig from "res-api-cli/build/config";

export default () => {
  if (!apiConfig.gtmId) return;

  TagManager.initialize({ gtmId: apiConfig.gtmId });
};
